<template>
    <svg class="svg" viewBox="0 0 388 194" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M220.174 8.05155L382.847 118.389C386.055 120.585 388 124.22 388 128.13V189.97C388 193.194 384.417 195.115 381.755 193.297L200.552 70.3717C196.594 67.6964 191.407 67.6964 187.448 70.3717L6.24486 193.263C3.58311 195.081 0 193.16 0 189.936V128.096C0 124.186 1.94512 120.55 5.15286 118.355L167.826 8.05155C183.66 -2.68385 204.374 -2.68385 220.174 8.05155Z"
            fill="#0032FF"
        />
    </svg>
</template>

<style lang="less" scoped>
    .svg {
        height: .convert(194px) [ @vw];
    }
</style>
